<template>
  <div id="col-12" v-show="$store.state.showBottomMenu">
    <div class="down-menu">
      <button :disabled="$store.state.disablePageNavigation" class="btn btn-sm buttonFooter" @click="firstPage"><i class="fas fa-chevron-circle-left"></i> First</button>
      <button :disabled="$store.state.disablePageNavigation" class="btn btn-sm buttonFooter" @click="prevPage"><i class="fas fa-chevron-left"></i> Prev</button>
      <button :disabled="$store.state.disablePageNavigation" class="btn btn-sm buttonFooter" @click="nextPage">Next <i class="fas fa-chevron-right"></i></button>
      <button :disabled="$store.state.disablePageNavigation" class="btn btn-sm buttonFooter" @click="lastPage">Last <i class="fas fa-chevron-circle-right"></i></button>
      <input :disabled="$store.state.disablePageNavigation" class="text" @change="setPage" type="number" min="1" max="99" maxlength="2" v-model="currentPage">
      <span class="numPage"> of {{ $store.state.totalPages }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'menu-bottom',

    data () {
      return {
        currentPage: 1
      }
    },

    mounted () {
      let that = this
      this.$bus.on('pageChange', function (pageNum) {
        that.currentPage = Number(pageNum)
      })

      let observer = new MutationObserver(function (mutations) {
        that.$store.commit('setDisablePageNavigation', false)
      })

      let options = {
        attributes: false,
        childList: true,
        characterData: false
      }

      observer.observe(document.getElementById('pageFields'), options)
    },

    methods: {
      setPage () {
        if (typeof Number(this.currentPage) === 'number') {
          let pageNum = Math.floor(Number(this.currentPage))
          if (pageNum < 1 || pageNum > this.$store.state.totalPages) {
            this.currentPage = this.$store.state.fileCurrentPage
            return
          } else {
            this.$store.commit('setDisablePageNavigation', true)
            this.$store.commit('setCurrentPage', Math.floor(Number(this.currentPage)))
            this.$bus.emit('pageChange', Math.floor(Number(this.currentPage)))
          }
        } else {
          this.currentPage = this.$store.state.fileCurrentPage
        }

        this.$bus.emit('hidePageFields')
      },

      firstPage () {
        if (this.$store.state.fileCurrentPage === 1) return
        this.$store.commit('setDisablePageNavigation', true)
        this.$store.commit('setCurrentPage', 1)
        this.$bus.emit('pageChange', 1)
        this.$bus.emit('hidePageFields')
      },

      lastPage () {
        if (this.$store.state.fileCurrentPage === this.$store.state.totalPages) return
        this.$store.commit('setDisablePageNavigation', true)
        this.$store.commit('setCurrentPage', this.$store.state.totalPages)
        this.$bus.emit('pageChange', this.$store.state.totalPages)

        this.$bus.emit('hidePageFields')
      },

      nextPage () {
        let pageNum = this.$store.state.fileCurrentPage + 1
        if (pageNum <= this.$store.state.totalPages) {
          // this.$store.commit('setDisablePageNavigation', true)
          this.$store.commit('setCurrentPage', this.$store.state.fileCurrentPage + 1)
          this.$bus.emit('pageChange', pageNum)

          this.$bus.emit('hidePageFields')
        }
      },

      prevPage () {
        let pageNum = this.$store.state.fileCurrentPage - 1
        if (pageNum > 0) {
          // this.$store.commit('setDisablePageNavigation', true)
          this.$store.commit('setCurrentPage', this.$store.state.fileCurrentPage - 1)
          this.$bus.emit('pageChange', pageNum)

          this.$bus.emit('hidePageFields')
        }
      }
    },

    beforeDestroy () {
      this.$bus.$off('pageChange')
      this.$store.commit('setCurrentPage', 1)
    }
  }
</script>

<style lang="scss" scoped>
  .down-menu {
    -webkit-box-shadow: 2px 0px 8px -3px rgba(0, 0, 0, 0.8);
    box-shadow: 2px 0px 8px -3px rgba(0, 0, 0, 0.8);
    position: fixed;
    -webkit-transform: translate(0%, 0);
    -ms-transform: translate(0%, 0);
    transform: translate(0%, 0);
    /* width: 450px; */
    width: 30%;
    text-align: center;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    background-color: #ececec;
    border: 1px solid black;
    border-radius: 5px 5px 0px 0px;
    bottom: 16px;
    padding-top: 15px;
    padding-bottom: 10px;
    z-index: 102;
    left: 25%;
    transform: translateX(-50%);
    /* left: 0;
    right: 0;
    margin: auto; */
    // margin-left: 120px;
    } 

  /* @media (max-width: 616px) {
      .down-menu-viewer {
          width: 400px; } } */

  .numPage {
      display: inline;
      font-size: 10pt; }

  .text {
      width: 50px;
      height: 29px;
      background-color: white;
      font-size: 10pt;
      text-align: center;
      border-radius: 5px;
      padding-bottom: 4px; }

  .buttonFooter {
    height: 100%;
    background-color: white;
    font-size: .830rem !important;
    border: 1px solid rgba(0, 0, 0, 0.46) !important;
    border-radius: 0.25rem !important;
    &:hover{
      background-color: #333333c9 !important;
    }
  }

  #bottomMenu {
    user-select: none;
    position: fixed;
    bottom: 0;
    left: 25%;
    transform: translateX(-50%);
    // right: 0;
    margin: 0 auto;
    z-index: 101;
    width: 600px;
    text-align: center;
    padding: 5px 25px 0 25px;
    color: #FFF;
    background-color: #2D5F8B;
    border-style: solid;
    border-color: #333;
    border-width: 3px 3px 0 3px;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    font-size: 18px;
  }

  input {
    display: inline-block;
    width: 75px;
    height: 35px;
    font-size: 20px;
    background-color: #FFF;
    border: 1px solid #333;
    color: #000;
    border-radius: 5px;
    text-align: center;

    &:disabled {
      opacity: 0.7;
    }
  }

  #pageControls {
    display: block;
    margin: 0 auto;
  }

  button {
    font-size: 16px;
    height: 35px;
    border-style: hidden;
    transition: .3s;
    &:hover {
      background-color: #333;
      color: white;
      transition: .3s;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/main/MenuBottom.vue